module.exports = __webpack_public_path__ + "img/houseImg.6d70041f.png";